import { Component, EventEmitter, Input, Output, SimpleChanges, ChangeDetectionStrategy } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatButtonToggleChange } from "@angular/material/button-toggle";
import { ListItem } from "src/app/models/listItem";
import { HelperService } from "src/app/services/helper.service";

@Component({
    selector: 'mwp-button-toggle',
    templateUrl: './button-toggle.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ButtonToggleComponent {
    @Input() public form: FormGroup;
    @Input() public nameForControl: string;
    @Input() public data: any[];
    @Input() public dataEnum: any;
    @Input() public keyText: string;
    @Input() public keyValue: string;
    @Input() public label: string;
    @Input() public autoTranslate: boolean = true;

    @Output() public emitSelected: EventEmitter<any> = new EventEmitter();

    public list: ListItem[];

    constructor(
        public helperService: HelperService
    ) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.list) {
            if (this.data)
                this.list = this.helperService.convertModelToList(this.data, this.keyText, this.keyValue);
            else
                this.list = this.helperService.convertEnumToList(this.dataEnum);
        }
    }

    public onChange(event: MatButtonToggleChange): void {
        if (event.source) {
            this.emitSelected.emit(event.source.value);
        }
    }
}